var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemThumbsDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.453 13.111h3.328V4.222h-3.328zm-5.73 6.667a1.46 1.46 0 0 1-1.11-.51 1.46 1.46 0 0 1-.347-1.177l.35-2.443.361-2.537H4.22l1.48-8.889h8.535v9.41l-.342.6zM19.78 2H5.698A2.22 2.22 0 0 0 3.51 3.857l-1.48 8.889a2.22 2.22 0 0 0 2.188 2.587H7.42l-.348 2.444a3.698 3.698 0 0 0 3.808 4.22c.741-.03 1.408-.475 1.776-1.12l3.163-5.544h3.963A2.22 2.22 0 0 0 22 13.111V4.222A2.22 2.22 0 0 0 19.781 2"
})));
export default SvgGemThumbsDown;